// themes/vanilla/index.js
//
// Central export point for the Vanilla theme
// Bundles theme configuration, events, and story content

import vanillaTheme from './vanillaTheme';
import vanillaEventsLibrary from './vanillaEvents';
import vanillaStoryLibrary from './vanillaStory';

/**
 * Vanilla Theme Bundle
 * Contains all configuration, content libraries, and narrative data
 * for the classic/default game experience
 */
const vanillaBundle = {
  // Theme configuration - visual, UI, and gameplay formatting
  theme: vanillaTheme,
  
  // Event content library - backdrop, threat, morale, faction, discovery, campaign events
  events: vanillaEventsLibrary,
  
  // Story content library - 4-chapter narrative arc and story threads
  story: vanillaStoryLibrary
};

export default vanillaBundle;

// Named exports for flexibility
export { vanillaTheme, vanillaEventsLibrary, vanillaStoryLibrary };